import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import PageAddUser from "../app/pages/admin-user/PageAddUser";
import PageProfil from "../app/pages/admin-user/PageProfil";
import PageUserList from "../app/pages/admin-user/PageUserList";
import Home from '../app/pages/home/Home';
import LandingPage from '../app/pages/landing-page/LandingPage';
import PasswordLinkRecovery from '../app/pages/password-recovery/PasswordLinkRecovery';
import PasswordUpdate from '../app/pages/password-recovery/PasswordUpdate';
import LPSupport from '../app/pages/support/_LPSupport';
import VitecPage from '../app/pages/vitec/VitecPage';

import ACC1Page from "../pages/ACC1/ACC1Page";
import CriteriaItemPage from "../pages/SS11/CriteriaItemPage";
import TallenesTalePage from "../pages/SS10/TallenesTalePage";
import LPVSE from '../pages/_heirloom/VSEPage';
import { AppState } from "../store/rootReducer";
import U from './Utils';
import requireAuth from "./requireAuth";
import NO01Page from '../pages/NO01/NO01Page';
//import NO02Page from '../pages/NO02/NO02Page';
import NV01Page from '../pages/NV01/NV01VARSPage';
import NV02Page from '../pages/NV02/NV02Page';
import NV03Page from "../pages/NV03/NV03Page";
import NF01Page from '../pages/NF01/NF01Page';
import NF02Page from '../pages/NF02/NF02Page';
import NF03Page from '../pages/NF03/NF03Page';
import NF04Page from '../pages/NF04/NF04Page';
import NF05Page from '../pages/NF05/NF05Page';
import NF06Page from '../pages/NF06/NF06Page';
import NF07Page from '../pages/NF07/NF07Page';
import NF08Page from '../pages/NF08/NF08Page';
import NF09Page from '../pages/NF09/NF09Page';
import NF10Page from '../pages/NF10/NF10Page';
import NF11Page from '../pages/NF11/NF11Page';
import NF12Page from '../pages/NF12/NF12Page';
import NN05Page from '../pages/NN05/NN05Page';
import NV04Page from '../pages/NV04/NV04Page';
import NV05Page from '../pages/NV05/NV05Page';
import NF13Page from '../pages/NF13/NF13Page';
import NO03Page from '../pages/NO03/NO03Page';
import { getUserJWTGroups, UserJWT } from '../models/UserJWT';

/**
 * Routes configuration for the application.
 * Author: fabrice.miras@vitecsoftware.com
 * Date: 29.07.2024
 */

// Common routes available to all users
const commonRoutes = [
  { path: U.HOMEPAGE_CONTEXT, element: <Home /> },
  { path: `${U.HOMEPAGE_CONTEXT}/home`, element: <Home /> },
  { path: `${U.HOMEPAGE_CONTEXT}/home`, element: <Home /> },
  { path: `${U.HOMEPAGE_CONTEXT}/login.html`, element: <Home /> },
  //{ path: `${U.HOMEPAGE_CONTEXT}/login`, element: <Home /> },
  { path: `${U.HOMEPAGE_CONTEXT}/menu`, element: React.createElement(requireAuth(LandingPage)) },
  { path: `${U.HOMEPAGE_CONTEXT}/vse`, element: React.createElement(requireAuth(LPVSE)) },
  { path: `${U.HOMEPAGE_CONTEXT}/support`, element: React.createElement(requireAuth(LPSupport)) },
  { path: `${U.HOMEPAGE_CONTEXT}/passwordlinkrecovery`, element: <PasswordLinkRecovery /> },
  { path: `${U.HOMEPAGE_CONTEXT}/passwordupdate`, element: <PasswordUpdate /> },
  { path: `${U.HOMEPAGE_CONTEXT}/vitec`, element: <VitecPage /> },
  { path: `${U.HOMEPAGE_CONTEXT}/BR04`, element: React.createElement(requireAuth(PageProfil)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NV01`, element: React.createElement(requireAuth(NV01Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NV02`, element: React.createElement(requireAuth(NV02Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NV04`, element: React.createElement(requireAuth(NV04Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NO01`, element: React.createElement(requireAuth(NO01Page)) },
  //{ path: `${U.HOMEPAGE_CONTEXT}/NO02`, element: React.createElement(requireAuth(NO02Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NV03`, element: React.createElement(requireAuth(NV03Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NV05`, element: React.createElement(requireAuth(NV05Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NN05`, element: React.createElement(requireAuth(NN05Page)) },
  // Filopplasting
  { path: `${U.HOMEPAGE_CONTEXT}/NF01`, element: React.createElement(requireAuth(NF01Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF02`, element: React.createElement(requireAuth(NF02Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF03`, element: React.createElement(requireAuth(NF03Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF04`, element: React.createElement(requireAuth(NF04Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF05`, element: React.createElement(requireAuth(NF05Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF06`, element: React.createElement(requireAuth(NF06Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF07`, element: React.createElement(requireAuth(NF07Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF08`, element: React.createElement(requireAuth(NF08Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF09`, element: React.createElement(requireAuth(NF09Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF10`, element: React.createElement(requireAuth(NF10Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF11`, element: React.createElement(requireAuth(NF11Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF12`, element: React.createElement(requireAuth(NF12Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NF13`, element: React.createElement(requireAuth(NF13Page)) },
  { path: `${U.HOMEPAGE_CONTEXT}/NO03`, element: React.createElement(requireAuth(NO03Page)) },
];

/**
 * Generates group-based routes based on user groups.
 * @param {Object} userJWT - The JWT token containing user groups.
 * @returns {Array} - Array of route objects.
 */
const groupBasedRoutes = (userJWT?: UserJWT) => {
  const routes: any = [];
  const groups = getUserJWTGroups(userJWT);
  const addAdminRoutes = (listPath: string, addPath: string) => {
    routes.push({ path: `${U.HOMEPAGE_CONTEXT}/${listPath}`, element: React.createElement(requireAuth(PageUserList)) });
    routes.push({ path: `${U.HOMEPAGE_CONTEXT}/${addPath}`, element: React.createElement(requireAuth(PageAddUser)) });
  };

  if (groups.includes('31') || groups.includes('32')) {
    routes.push({ path: `${U.HOMEPAGE_CONTEXT}/SS10`, element: React.createElement(requireAuth(TallenesTalePage)) });
  }
  if (groups.includes('32')) {
    routes.push({ path: `${U.HOMEPAGE_CONTEXT}/SS11`, element: React.createElement(requireAuth(CriteriaItemPage)) });
  }
  if (groups.includes('ADMIN')) {
    addAdminRoutes('BR00', 'BR01');
  }
  if (groups.includes('MINIADMIN')) {
    addAdminRoutes('BR02', 'BR03');
  }
  if (groups.includes('22')) {
    routes.push({ path: `${U.HOMEPAGE_CONTEXT}/ACC1`, element: React.createElement(requireAuth(ACC1Page, 'ACC1')) });
  }

  return routes;
};

/**
 * Combines common routes and group-based routes into a single route configuration.
 * @param {Object} userJWT - The JWT token containing user groups.
 * @returns {Array} - Array of JSX Route elements.
 */
const generateRoutes = (userJWT?: UserJWT) => {
  const routes = [
    ...commonRoutes,
    ...groupBasedRoutes(userJWT),
    { path: `${U.HOMEPAGE_CONTEXT}/robots.txt`, element: <Navigate to={`${U.HOMEPAGE_CONTEXT}/robots.txt`} replace={true} /> },
    { path: '*', element: <Navigate to={`${U.HOMEPAGE_CONTEXT}/menu`} replace={true} /> },
  ];

  return routes.map((route, index) => <Route key={index} path={route.path} element={route.element} />);
};

/**
 * Main function to get the route configuration based on user authentication.
 * @returns {JSX.Element} - Routes JSX element containing all route configurations.
 */
export default function getRoutes() {
  const userJWT = useSelector((state: AppState) => state.auth.userJWT);
  const routes = generateRoutes(userJWT);
  return <Routes>{routes}</Routes>;
}
